import * as React from 'react'
export default function DiscoBtnIcon(props: {
  size: string
}): React.ReactElement<'svg'> {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 -4.5 34 38"
      style={{
        verticalAlign: 'middle',
      }}
    >
      <path
        fill="currentColor"
        d="M30.816 0C32.607 0 34 1.5 34 3.4v21.2c0 1.9-1.393 3.4-3.184 3.4H3.184C1.393 28 0 26.5 0 24.6V3.4C0 1.5 1.393 0 3.184 0h27.632zM4.036 19H9.09c1.834 0 3.15-1.064 3.15-2.604 0-1.064-.644-1.96-1.764-2.464.854-.448 1.344-1.162 1.344-2.142 0-1.4-1.19-2.408-2.912-2.408H4.036V19zm2.058-5.74v-2.114H8.39c.77 0 1.316.448 1.316 1.05 0 .616-.546 1.064-1.316 1.064H6.094zm0 3.976v-2.352h2.618c.826 0 1.414.49 1.414 1.176 0 .686-.588 1.176-1.414 1.176H6.094zM15.45 19h2.072v-7.756h2.996V9.382h-8.064v1.862h2.996V19zm5.758 0h2.058v-6.216L27.9 19h2.072V9.382H27.9v6.216l-4.634-6.216h-2.058V19z"
      />
    </svg>
  )
}
